import styled from 'styled-components';
import colors from 'theme/colors';

export const FieldFileUploadFrame = styled.div`
  border-radius: 3px;
  border: 1px solid ${colors.lightGray};
  background-color: ${colors.lightestGray};
  min-height: 25.75rem;
  padding: 0.625rem;
  width: 18.75rem;
  position: relative;
`;

export const FieldFileUploadPreview = styled.section`
  img {
    width: 100%;
    height: auto;
  }
  .react-pdf__Document {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 17.5rem;
  }
`;

export const FieldFileUploadPreviewHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 0.5rem;
  font-size: 0.813rem;
  color: ${colors.primary};

  label {
    .anticon {
      color: ${colors.black}
      font-size: 0.813rem;
    }
    font-size: 0.813rem;
  }
  
  .FieldFileUploadPreviewTools {
    .anticon {
      &:hover {
        filter: brightness(1.3);
      }
    }
  }
`;

export const FieldFileUploaderContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 20.625rem;
  label {
    font-weight: 600;
  }
  p {
    color: ${colors.gray};
    text-align: center;
    margin: 0.313rem 0 1rem;
    line-height: 1;
  }
`;
